import { render, staticRenderFns } from "./Patch.vue?vue&type=template&id=ae7152da&"
import script from "./Patch.vue?vue&type=script&lang=js&"
export * from "./Patch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports